import styled from "styled-components";
import { COLOR } from "../helpers/theme";

const XrDataTable = styled.div`
  margin-top: 20px;
  border-radius: 5px;
  border: 1px solid #e2e2e2;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.08);

  & > .tablewrapper--title {
    font-size: 14px;
    font-weight: 700;
    color: #161616;
    background-color: #fff;
    padding: 10px 20px 10px 20px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: 1px solid #e2e2e2;
  }

  .tablewrapper--loading {
    text-align: center;

    & > .tablewrapper--loading--caption {
      display: flex;
      align-items: center;
      justify-content: center;

      & > span {
        margin-left: 5px;
      }
    }
  }

  & > .tablewrapper--table {
    width: 100%;

    & > table {
      border-spacing: 0;
      min-width: 100%;
      text-align: left;
      border-collapse: collapse;

      & > thead {
        background: #fff;
        border-bottom: 1px solid #e2e2e2;
      }

      & > thead.field-filter {
        & tr > th > * {
          width: 100%;
          padding: 5px 10px 5px 10px;
          border: 1px solid #e2e2e2;
          border-radius: 5px;
          -webkit-appearance: none;
        }
      }

      & > thead > tr > th {
        font-size: 14px;
        cursor: pointer;
        padding: 10px;
      }

      & > tbody > tr {
        padding-bottom: 5px;
        border-bottom: 1px solid #e2e2e2;
      }

      & > tbody > tr:last-child {
        border-bottom: 1px solid transparent !important;
      }

      & > tbody > tr > td {
        background: #fff;
        font-size: 14px;
        padding: 10px 15px 10px 15px;

        & .broken {
          font-weight: 800;
          color: red;
        }
      }

      & > tbody > tr:last-child td:first-child {
        border-bottom-left-radius: var(--corner-radius-small);
      }

      & > tbody > tr:last-child td:last-child {
        border-bottom-right-radius: var(--corner-radius-small);
      }

      .sortArrow {
        width: 8px;
        margin-left: 5px;
      }
    }
  }
`;

export default XrDataTable;